import { render } from "./CourseModules.vue?vue&type=template&id=2242bc99&scoped=true"
import script from "./CourseModules.vue?vue&type=script&lang=js"
export * from "./CourseModules.vue?vue&type=script&lang=js"

import "./CourseModules.vue?vue&type=style&index=0&id=2242bc99&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2242bc99"]])

export default __exports__